<div class="preview d-flex direction-column">
  <div class="preview-header">
    <h1 class="preview-title" mat-dialog-title>{{ data.title }}</h1>
    <span class="preview-subtitle">
      Prévia com os dados atuais. Nada é enviado.
      <ng-container *ngIf="tabs.length > 1">
        <ng-container *ngIf="loadedCount === tabs.length; else counting">
          {{ sendCount }} de {{ tabs.length }} sublotes enviariam e-mail.
        </ng-container>
        <ng-template #counting>Carregando {{ loadedCount }} de {{ tabs.length }} sublotes…</ng-template>
      </ng-container>
    </span>
  </div>

  <div class="preview-tabs" *ngIf="tabs.length > 1">
    <button
      *ngFor="let tab of tabs; let i = index"
      type="button"
      class="preview-tab"
      [class.preview-tab--active]="i === selectedIndex"
      [matTooltip]="tab.BeneficiaryName ?? ''"
      (click)="selectTab(i)">
      <span *ngIf="isLoading(tab); else status" class="preview-spinner preview-spinner--small"></span>
      <ng-template #status>
        <span class="preview-dot" [class.preview-dot--off]="!preview(tab)?.WillSend"></span>
      </ng-template>
      {{ tab.BatchNumber }}
    </button>
  </div>

  <!-- Sem abas conhecidas (lote sem sublotes na tela): espera a única resposta. -->
  <div class="preview-state" *ngIf="!tabs.length">
    <ng-container *ngIf="!failed.size; else loadError">
      <span class="preview-spinner"></span> Montando a prévia…
    </ng-container>
  </div>

  <div class="preview-content" *ngIf="selected as tab">
    <div class="preview-state" *ngIf="isLoading(tab)">
      <span class="preview-spinner"></span>
      Montando a prévia de {{ tab.BeneficiaryName || tab.BatchNumber }}…
    </div>

    <ng-container *ngIf="failed.has(tab.BatchId)">
      <ng-container *ngTemplateOutlet="loadError"></ng-container>
    </ng-container>

    <ng-container *ngIf="preview(tab) as preview">
      <div class="preview-alert preview-alert--danger" *ngIf="!preview.WillSend">
        <strong>Este e-mail não seria enviado.</strong> {{ preview.Reason }}
      </div>
      <div class="preview-alert preview-alert--warning" *ngFor="let warning of preview.Warnings">
        {{ warning }}
      </div>

      <dl class="preview-fields">
        <dt>Beneficiário</dt>
        <dd>{{ preview.BeneficiaryName || '—' }} <span class="preview-muted">{{ preview.BeneficiaryDocument }}</span></dd>

        <ng-container *ngIf="preview.EventName">
          <dt>Para</dt>
          <dd>
            <ng-container *ngIf="recipients(preview).length; else noRecipients">
              <span class="preview-chip" *ngFor="let email of recipients(preview)">{{ email }}</span>
            </ng-container>
            <ng-template #noRecipients><span class="preview-muted">nenhum destinatário</span></ng-template>
          </dd>

          <dt>Template</dt>
          <dd>{{ preview.EventName }}</dd>

          <ng-container *ngIf="preview.Attachments.length">
            <dt>Anexos</dt>
            <dd>
              <a class="preview-chip" *ngFor="let url of preview.Attachments" [href]="url" target="_blank" rel="noopener">
                {{ attachmentName(url) }}
              </a>
            </dd>
          </ng-container>

          <ng-container *ngIf="preview.Subject !== undefined && preview.Subject !== null">
            <dt>Assunto</dt>
            <dd class="preview-subject">{{ preview.Subject }}</dd>
          </ng-container>
        </ng-container>
      </dl>

      <iframe
        *ngIf="preview.Body"
        class="preview-body"
        sandbox=""
        title="Corpo do e-mail"
        [srcdoc]="bodyFor(preview)">
      </iframe>
    </ng-container>
  </div>

  <ng-template #loadError>
    <div class="preview-alert preview-alert--danger">
      Não foi possível montar a prévia. Feche e tente de novo.
    </div>
  </ng-template>

  <div class="preview-actions d-flex justify-end" mat-dialog-actions>
    <button class="ui-btn ui-btn--secondary" type="button" mat-dialog-close>Fechar</button>
  </div>
</div>
